import React from 'react'
import { InfoCircleOutlined } from '@ant-design/icons'
import { Tooltip, TooltipProps } from 'antd'
import { IconButton } from './styles'

interface DescriptionTooltipIconProps {
  description: string
  placement?: TooltipProps['placement']
}

export function DescriptionTooltipIcon({
  description,
  placement = 'right',
}: DescriptionTooltipIconProps) {
  const stopInteraction = (event: React.SyntheticEvent<HTMLButtonElement>) => {
    event.preventDefault()
    event.stopPropagation()
  }

  return (
    <Tooltip
      title={description}
      placement={placement}
      trigger={['hover', 'focus']}
      mouseEnterDelay={0.15}
      styles={{ root: { maxWidth: 420 } }}
    >
      <IconButton
        type="button"
        aria-label="Показать расшифровку"
        onMouseDown={stopInteraction}
        onClick={stopInteraction}
      >
        <InfoCircleOutlined />
      </IconButton>
    </Tooltip>
  )
}
